import { RadioBoolean } from "@foodpilot/foods";
import { Stack, Button, Typography } from "@mui/material";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { useUpsertAppParam } from "src/api/client-api/appParams";
import {
    ApplicationParameterKeys,
    useApplicationParameters,
} from "src/api/client-api/appParams/useApplicationParameters";

type BaseStringUploadProps = {
    appParamKey: ApplicationParameterKeys;
    label: string;
    description?: string;
    extraConfiguration?: () => void;
    forceReload?: boolean;
};
export const BaseToggleUpload = (props: BaseStringUploadProps) => {
    const { appParamKey, label, description, extraConfiguration, forceReload = true } = props;

    const defaultBooleanValue = false;
    const { applicationParameters } = useApplicationParameters();
    const upsertAppParam = useUpsertAppParam({ forceReload });
    const { t } = useTranslation();

    const _originalValue = applicationParameters?.[appParamKey];
    const originalValue =
        _originalValue === undefined ? defaultBooleanValue
        : _originalValue === "true" ? true
        : false;

    const [value, setValue] = useState<boolean>(originalValue);

    return (
        <Stack flexDirection={"row"} gap="16px">
            <Stack>
                <Stack flexDirection={"row"} gap="16px">
                    <Typography variant="big-bold">{`${label}`}</Typography>
                    {description && (
                        <Fragment>
                            <Typography variant="big-bold">{`-`}</Typography>
                            <Typography variant="body-medium">{`${description}`}</Typography>
                        </Fragment>
                    )}
                </Stack>
                <Stack flexDirection={"row"} gap={"16px"}>
                    <RadioBoolean
                        value={value}
                        onChange={(newValue) => {
                            setValue(newValue);
                        }}
                    />
                    {extraConfiguration !== undefined && (
                        <Button
                            variant="ternary"
                            onClick={() => {
                                extraConfiguration();
                            }}
                        >
                            {"Configurer"}
                        </Button>
                    )}
                </Stack>
                <Button
                    sx={{ display: "flex", justifyContent: "left" }}
                    variant="text"
                    onClick={() => {
                        upsertAppParam.mutate({
                            isNew: _originalValue === undefined ? true : false,
                            key: appParamKey,
                            value: String(value),
                        });
                    }}
                >
                    {t("primarydialog.validate")}
                </Button>
            </Stack>
        </Stack>
    );
};
